import * as z from "zod";
import { V2_ADMIN_PRODUCT_IDS, type V2AdminProductId } from "./admin-products";

/** Per-product status for v2 onboarding UI (includes not-started when no row). */
export const onboardingV2ProductStatusUiSchema = z.enum([
  "completed",
  "partial-completion",
  "help-requested",
  "not-started",
]);

export type OnboardingV2ProductStatusUi = z.infer<
  typeof onboardingV2ProductStatusUiSchema
>;

export const onboardingV2ProductShellStateSchema = z.object({
  status: onboardingV2ProductStatusUiSchema,
  isArchived: z.boolean(),
});

export type OnboardingV2ProductShellState = z.infer<
  typeof onboardingV2ProductShellStateSchema
>;

/**
 * Zod object schema where every admin product id is a required key. We
 * build the shape from `V2_ADMIN_PRODUCT_IDS` so adding a product to the
 * registry automatically extends the schema with no parallel edits here.
 */
const onboardingV2ProductStatesSchema = z.object(
  Object.fromEntries(
    V2_ADMIN_PRODUCT_IDS.map(
      (id) => [id, onboardingV2ProductShellStateSchema] as const,
    ),
  ) as Record<V2AdminProductId, typeof onboardingV2ProductShellStateSchema>,
);

export type OnboardingV2ProductStates = Record<
  V2AdminProductId,
  OnboardingV2ProductShellState
>;

export const getOnboardingV2ProductStatuses = {
  name: "getOnboardingV2ProductStatuses" as const,
  input: z.object({ teamId: z.string().min(1) }),
  output: z.object({
    teamName: z.string(),
    teamDomain: z.string().nullable(),
    products: onboardingV2ProductStatesSchema,
  }),
};

export type GetOnboardingV2ProductStatusesInput = z.infer<
  typeof getOnboardingV2ProductStatuses.input
>;
export type GetOnboardingV2ProductStatusesOutput = z.infer<
  typeof getOnboardingV2ProductStatuses.output
>;
